import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import {
  getPagination,
  getFilters,
  getVisibleRecords,
  getNeedFetch,
  getIsLoading,
  getIsImporting,
} from 'import/selectors';
import { fetch, setPagination, setFilters, importFile } from 'import/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';
import { valueFromEvent, createRoute } from 'lib/util';

import * as Import from 'import/components';
import * as ImportList from 'import/components/list';
import { withRouter } from 'react-router-dom';

class ImportListContainer extends PureComponent {
  state = {
    urlCSV: null,
    module: null,
    header: null,
    isReImportModalOpen: false,
  };

  resetState = () => {
    this.setState({
      urlCSV: null,
      module: null,
      header: null,
      isReImportModalOpen: false,
    });
  };

  componentWillMount = () => this.fetch(this.props.pagination, this.props.filters);

  //
  handleReImportCSV = (urlCSV, module, header) => {
    this.setState({
      urlCSV,
      module,
      header,
      isReImportModalOpen: true,
    });
  };

  getCSVFromURL = async (url) => {
    // console.log(url)
    let file = null;
    return new Promise((resolve, reject) => {
      var request = new XMLHttpRequest();
      // request.responseType = "blob";
      request.open('GET', url, true);
      // request.addEventListener('progress', function (event) {
      // });

      // request.addEventListener('load', function (event) {
      //   if (request.status >= 200 && request.status < 300) {
      //     // console.log(request.responseText);
      //     file = request.responseText;
      //     resolve(file);
      //   } else {
      //     console.warn(request.statusText, request.responseText);
      //     reject(new DOMException("Problem parsing file."));
      //   }
      // });

      request.onload = function (oEvent) {
        if (request.status >= 200 && request.status < 300) {
          // console.log(request.responseText);
          file = request.responseText;
          resolve(file);
        } else {
          console.warn(request.statusText, request.responseText);
          reject(new DOMException('Problem parsing file.'));
        }
        // file = request.responseText;
        // resolve(file);
        // var blob = oReq.response;
        // ...
      };
      request.send();
    });
  };

  handleCancelReImportCSV = () => {
    this.resetState();
  };

  handleSelectHeaders = async () => {
    const file = await this.getCSVFromURL(this.state.urlCSV);
    const urlCSV = this.state.urlCSV;
    const module = this.state.module;
    await this.resetState();
    this.props.history.push({
      pathname: createRoute(this.props.company.id, this.props.subcompany.id, 'import/add'),
      state: {
        urlCSV,
        module,
        file,
      },
    });
  };

  handleAcceptReImportCSV = async () => {
    try {
      const {
        value: { message },
      } = await this.props.importFile(this.props.company.id, this.props.subcompany.id, {
        url: this.state.urlCSV,
        modul: this.state.module,
        colums: this.state.header,
      });
      this.props.success(message);
      this.resetState();
      this.props.history.push(
        createRoute(this.props.company.id, this.props.subcompany.id, 'import')
      );
    } catch (e) {
      this.props.history.push(
        createRoute(this.props.company.id, this.props.subcompany.id, 'import')
      );
      this.resetState();
      return this.props.error('import.error.importing');
    }
  };

  componentWillReceiveProps = (nextProps) =>
    nextProps.needFetch && this.fetch(nextProps.pagination, nextProps.filters);

  fetch = (pagination, filters) =>
    this.props.fetch(
      this.props.company.id,
      this.props.subcompany.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );

  fetchDebounced = debounce(this.fetch, 150);

  handleFiltersChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleFiltersSubmit = () => this.fetch(this.props.pagination, this.props.filters);

  handleLimitChange = (limit) => this.props.setPagination({ limit: parseInt(limit, 10) });

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handlePageChange = (page) => this.props.setPagination({ page: parseInt(page, 10) });

  renderRows = () => {
    return this.props.records.map((record) => (
      <ImportList.Row
        key={record.createdAt}
        record={record}
        isImporting={this.props.isImporting}
        handleReImportCSV={this.handleReImportCSV}
      />
    ));
  };

  render() {
    return (
      <Import.ListView
        company={this.props.company}
        subcompany={this.props.subcompany}
        handleReImportCSV={this.handleReImportCSV}
        handleFiltersChange={this.handleFiltersChange}
        handleFiltersSubmit={this.handleFiltersSubmit}
        handleOrderChange={this.handleOrderChange}
        handleLimitChange={this.handleLimitChange}
        handlePageChange={this.handlePageChange}
        handleAccept={this.handleAcceptReImportCSV}
        handleSelectHeaders={this.handleSelectHeaders}
        handleClose={this.handleCancelReImportCSV}
        isOpened={this.state.isReImportModalOpen}
        modulo={this.state.module}
        isLoading={this.props.isLoading}
        records={this.props.records}
        filters={this.props.filters}
        pagination={this.props.pagination}
        permissions={this.props.permissions}
      >
        {this.renderRows()}
      </Import.ListView>
    );
  }
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  pagination: getPagination(state),
  permissions: getPermissions(state),
  records: getVisibleRecords(state),
  filters: getFilters(state),
  needFetch: getNeedFetch(state),
  isLoading: getIsLoading(state),
  isImporting: getIsImporting(state),
});

const mapDispatchToProps = {
  fetch,
  setPagination,
  importFile,
  setFilters,
  error,
  success,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ImportListContainer));



// WEBPACK FOOTER //
// src/modules/secured/modules/import/containers/ImportListContainer.js